/** Lesbare Einheiten für Vorlagen. */
export const deg = (d: number) => (d * Math.PI) / 180;
export const rpm = (n: number) => (n * Math.PI) / 30;
export const mm = (x: number) => x / 1000;
export const inch = (i: number) => i * 0.0254;
export const bar = (b: number) => b * 1e5;
